import M from "materialize-css";
export function Toast(text) {
    M.toast({ html: text });
}
export function ErrorToast(text) {
    M.toast({ html: text, classes: "error-toast", displayLength: 60000 });
}
